export default __webpack_public_path__ + "static/media/region_norrbotten_logo.9ef3303d.eps";